import LayoutConfig from "./LayoutConfigTypes";

const DefaultThemeConfig: LayoutConfig = {
  name: "Start",
  fullName: "Start Vue Free",
  version: "v1.0.0"
};

export default DefaultThemeConfig;
